import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-900 text-gray-100 p-4">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-2xl mb-8">Oops! This page doesn't exist.</p>
      <Link
        to="/"
        className="px-6 py-3 bg-[#FF9900] text-white rounded-md hover:bg-[#FFB84D] transition-colors"
      >
        Go Back to Main Page
      </Link>
    </div>
  );
};

export default NotFound;
